import { LocationPage } from "@/components/locations/LocationPage";
import { getLocationBySlug } from "@/data/locations";

const BookkeepingServicesJohannesburg = () => {
  const location = getLocationBySlug("johannesburg")!;
  return <LocationPage location={location} />;
};

export default BookkeepingServicesJohannesburg;
